<template>
  <v-data-table
    v-if="items.length > 0"
    :items="items"
    :headers="tableHeaders"
    hide-default-footer
  >
    <template v-slot:[`item.actions`]="{item}">
      <v-btn @click="deleteItem(item._id)" icon><v-icon>mdi-delete</v-icon></v-btn>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'selected-services',

  props: {
    value: Array
  },

  data() {
    return {
      tableHeaders: [
        {
          text: 'Наименование',
          value: 'name'
        },
        {
          text: 'Ед.изм.',
          value: 'unitName'
        },
        {
          text: 'Кол-во',
          value: 'count'
        },
        {
          text: '',
          value: 'actions'
        }
      ],
    }
  },

  methods: {
    deleteItem(id) {
      let newValue = _.cloneDeep(this.value);
      let elem = newValue.find(x => x._id == id);
      elem.count = 0;
      elem.isActive = false;
      this.$emit('input', newValue);
    }
  },

  computed: {
    items() {
      return this.value.filter(x => x.isActive && x.count > 0);
    },
  }
}
</script>